// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { calendarCircleExclamation16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-calendar-circle-exclamation': IconCalendarCircleExclamation;
    }
}

/**
 * The icon component for the 'calendarCircleExclamation' icon
 */
export class IconCalendarCircleExclamation extends IconSvg {
    public constructor() {
        super(calendarCircleExclamation16X16);
    }
}

registerIconSvg('icon-calendar-circle-exclamation', IconCalendarCircleExclamation);
export const iconCalendarCircleExclamationTag = 'nimble-icon-calendar-circle-exclamation';
